"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ContentTabs", {
  enumerable: true,
  get: function get() {
    return _generatedTypes.ProductCardContentTabEnum;
  }
});
Object.defineProperty(exports, "DEFAULT_TAB_ORDER", {
  enumerable: true,
  get: function get() {
    return _constants.DEFAULT_TAB_ORDER;
  }
});
Object.defineProperty(exports, "PreheaderTypes", {
  enumerable: true,
  get: function get() {
    return _preheader.PREHEADER_TYPE;
  }
});
Object.defineProperty(exports, "SentimentTypes", {
  enumerable: true,
  get: function get() {
    return _preheader.SENTIMENT_TYPE;
  }
});
exports.default = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
require("core-js/modules/es6.array.map.js");
require("core-js/modules/es6.array.filter.js");
require("core-js/modules/es7.object.values.js");
var _values2 = _interopRequireDefault(require("lodash/values"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _react = _interopRequireWildcard(require("react"));
var _reactMarketplaceCta = _interopRequireWildcard(require("@nerdwallet/react-marketplace-cta"));
var _reactMarketplaceReviewLink = require("@nerdwallet/react-marketplace-review-link");
var _reactMarketplaceStarRating = require("@nerdwallet/react-marketplace-star-rating");
var _variables = require("@nerdwallet/base-styles/variables");
var _apollo = require("@nerdwallet/apollo");
var _reactProductCardBanner = _interopRequireWildcard(require("@nerdwallet/react-product-card-banner"));
var _classnames = _interopRequireDefault(require("classnames"));
var _currency = require("@nerdwallet/currency");
var _baseMarketplaceProductCardScaffold = _interopRequireDefault(require("./base-marketplace-product-card-scaffold"));
var _drivers = require("./drivers");
var _constants = require("./lib/constants");
var _preheader = _interopRequireWildcard(require("./preheader"));
var _productCardImageWrapper = _interopRequireDefault(require("./product-card-image-wrapper"));
var _content = require("./content");
var _header = require("./header");
var _productCtas = require("./product-ctas");
var _matchScoreCta = require("./match-score-cta/match-score-cta");
var _controlStatements = require("./control-statements");
var _render = require("./lib/utils/render");
var _utils = require("./lib/utils");
var _generatedTypes = require("./types/graphql/generated-types");
var _marketplaceProductCardModule = _interopRequireDefault(require("./marketplace-product-card.module.css"));
var _addToFavorites = _interopRequireDefault(require("./product-ctas/add-to-favorites"));
var _templateObject;
/**
 * Exposed analytics config on each sub-section.
 */

/**
 * MarketplaceProductCard with data fallbacks provided by way of a GraphQL sponsored Marketplace data object.
 */
var GraphQlMarketplaceProductCard = function GraphQlMarketplaceProductCard(_ref) {
  var _placementDrivers, _structuredContentCon, _structuredContentPro, _analytics$contentPro;
  var analytics = _ref.analytics,
    approvalLikelihood = _ref.approvalLikelihood,
    approvalOddsEnabled = _ref.approvalOddsEnabled,
    bottomLine = _ref.bottomLine,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    cons = _ref.cons,
    _ref$consRenderer = _ref.consRenderer,
    consRenderer = _ref$consRenderer === void 0 ? _render.defaultRenderer : _ref$consRenderer,
    cta = _ref.cta,
    ctaTrackingParams = _ref.ctaTrackingParams,
    _ref$driverRenderer = _ref.driverRenderer,
    driverRenderer = _ref$driverRenderer === void 0 ? _render.defaultRenderer : _ref$driverRenderer,
    imageOverlay = _ref.imageOverlay,
    gqlMarketplaceEntity = _ref.gqlMarketplaceEntity,
    hasAccordionOnMobile = _ref.hasAccordionOnMobile,
    heading = _ref.heading,
    identity = _ref.identity,
    image = _ref.image,
    isInitTabContentExpanded = _ref.isInitTabContentExpanded,
    isLazyLoadEnabled = _ref.isLazyLoadEnabled,
    keyFacts = _ref.keyFacts,
    omitRatingTextHref = _ref.omitRatingTextHref,
    placementDrivers = _ref.placementDrivers,
    preheaderConfig = _ref.preheader,
    productDetails = _ref.productDetails,
    pros = _ref.pros,
    _ref$prosRenderer = _ref.prosRenderer,
    prosRenderer = _ref$prosRenderer === void 0 ? _render.defaultRenderer : _ref$prosRenderer,
    reviewLinkHref = _ref.reviewLinkHref,
    secondaryCta = _ref.secondaryCta,
    shouldOmitCta = _ref.shouldOmitCta,
    shouldOmitRating = _ref.shouldOmitRating,
    shouldOmitRatingText = _ref.shouldOmitRatingText,
    shouldShowMatchScoreCta = _ref.shouldShowMatchScoreCta,
    shouldShowNAValues = _ref.shouldShowNAValues,
    shouldOmitCreditScoreDriver = _ref.shouldOmitCreditScoreDriver,
    _ref$shouldEnableFavo = _ref.shouldEnableFavorites,
    shouldEnableFavorites = _ref$shouldEnableFavo === void 0 ? false : _ref$shouldEnableFavo,
    _ref$isFavorited = _ref.isFavorited,
    isFavorited = _ref$isFavorited === void 0 ? false : _ref$isFavorited,
    _ref$favoriteCallback = _ref.favoriteCallback,
    favoriteCallback = _ref$favoriteCallback === void 0 ? function () {} : _ref$favoriteCallback,
    showBestOfAwards = _ref.showBestOfAwards,
    tabs = _ref.tabs,
    _ref$tagLineRenderer = _ref.tagLineRenderer,
    BottomLineRenderer = _ref$tagLineRenderer === void 0 ? _render.defaultRenderer : _ref$tagLineRenderer,
    trkElementPosition = _ref.trkElementPosition,
    trkPageType = _ref.trkPageType,
    trkSectionCategory = _ref.trkSectionCategory,
    trkSectionPosition = _ref.trkSectionPosition,
    trkTaxonomy = _ref.trkTaxonomy,
    shouldDisplayPlaceHolder = _ref.shouldDisplayPlaceHolder,
    shouldHideDetails = _ref.shouldHideDetails,
    hasBanner = _ref.hasBanner,
    bannerText = _ref.bannerText,
    bannerType = _ref.bannerType,
    addCategoryHeader = _ref.addCategoryHeader,
    postApplyOnClick = _ref.postApplyOnClick,
    showCreditScorePill = _ref.showCreditScorePill;
  var mpcTrkSectionCategory = (0, _utils.buildTrkSectionCategory)(trkSectionCategory, _constants.TRK_PRODUCT_LOCATION);
  /**
   * GraphQlMarketplaceCta only consumes the "raw" payload analytics overrides.
   * Transform prop-based config into the format expected.
   *
   * @todo We should decide on an convention for `analytics` prop interfacing and stick to that.
   */
  var getMarketplaceCtaAnalyticsPayload = function getMarketplaceCtaAnalyticsPayload() {
    var _analytics$productCta, _analytics$productCta2;
    return {
      section_name: (analytics === null || analytics === void 0 ? void 0 : (_analytics$productCta = analytics.productCtaProps) === null || _analytics$productCta === void 0 ? void 0 : _analytics$productCta.sectionName) || _constants.COMPONENT_ANALYTICS_NAME,
      section_position: analytics === null || analytics === void 0 ? void 0 : (_analytics$productCta2 = analytics.productCtaProps) === null || _analytics$productCta2 === void 0 ? void 0 : _analytics$productCta2.sectionPosition
    };
  };

  /**
   * Product card image data.
   */
  var imageData = (0, _utils.getImageDataFromEntityPlacementImage)(image || (gqlMarketplaceEntity === null || gqlMarketplaceEntity === void 0 ? void 0 : gqlMarketplaceEntity.image));
  var productCardImage = /*#__PURE__*/_react.default.createElement(_productCardImageWrapper.default, {
    imageData: imageData,
    backgroundColor: _variables.colors.transparent,
    imageClassName: _marketplaceProductCardModule.default.productImage,
    className: _marketplaceProductCardModule.default.productImageWrapper,
    objectFit: "contain",
    lazyLoadEnabled: isLazyLoadEnabled,
    isKetoCard: false,
    imageOverlay: imageOverlay,
    shouldDisplayPlaceHolder: shouldDisplayPlaceHolder
  });

  /**
   * Lightweight util for generation of product ctas.
   */
  var getProductCtas = function getProductCtas(ctaClassName, ctaLocation) {
    return !shouldOmitCta ? /*#__PURE__*/_react.default.createElement(_productCtas.ProductCtas, {
      className: ctaClassName,
      primaryCtaNode: /*#__PURE__*/_react.default.createElement(_reactMarketplaceCta.default, {
        analyticsPayloadOverrides: getMarketplaceCtaAnalyticsPayload(),
        cta: cta,
        gqlMarketplaceEntity: gqlMarketplaceEntity,
        id: "".concat(_constants.TRK_PRODUCT_LOCATION, "__primary-product-cta--").concat(ctaLocation, "--").concat(gqlMarketplaceEntity === null || gqlMarketplaceEntity === void 0 ? void 0 : gqlMarketplaceEntity.id),
        legacyTrkProps: {
          trkTaxonomy: trkTaxonomy,
          trkLocation: _constants.TRK_PRODUCT_LOCATION,
          trkPageType: trkPageType,
          trkSectionCategory: mpcTrkSectionCategory
        },
        linkType: _reactMarketplaceCta.LINK_TYPES.applyNowButton,
        omitImpression: true,
        reviewLinkOverride: reviewLinkHref,
        urlSearchParams: ctaTrackingParams,
        onClick: !!postApplyOnClick && postApplyOnClick
      }),
      secondaryCtaNode:
      /*#__PURE__*/
      // Secondary CTA -- "View Rates & Fees"
      _react.default.createElement(_reactMarketplaceCta.default, {
        analyticsPayloadOverrides: getMarketplaceCtaAnalyticsPayload(),
        cta: secondaryCta || (0, _utils.isCCOffer)(gqlMarketplaceEntity) ? gqlMarketplaceEntity === null || gqlMarketplaceEntity === void 0 ? void 0 : gqlMarketplaceEntity.ratesAndFeesCta : null,
        disableAnnotation: true
        /**
         * @todo - Currently we use <MarketplaceApplyNow /> for "View Rates & Fees".
         * Perhaps we should just use a regular button instead of converting to <MarketplaceCta />.
         */,
        gqlMarketplaceEntity: {},
        id: "".concat(_constants.TRK_PRODUCT_LOCATION, "__secondary-product-cta--").concat(ctaLocation, "--").concat(gqlMarketplaceEntity === null || gqlMarketplaceEntity === void 0 ? void 0 : gqlMarketplaceEntity.id),
        legacyTrkProps: {
          trkTaxonomy: trkTaxonomy,
          trkLocation: _constants.TRK_PRODUCT_LOCATION,
          trkPageType: trkPageType,
          trkSectionCategory: mpcTrkSectionCategory
        },
        linkType: _reactMarketplaceCta.LINK_TYPES.applyLink,
        omitImpression: true,
        urlSearchParams: ctaTrackingParams
      })
    }) : null;
  };
  var driversAndContent = /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_drivers.GqlProductDrivers, {
    analytics: {
      driversProps: analytics === null || analytics === void 0 ? void 0 : analytics.driversProps,
      loaCtaProps: analytics === null || analytics === void 0 ? void 0 : analytics.loaCtaProps
    },
    approvalOddsEnabled: approvalOddsEnabled,
    className: _marketplaceProductCardModule.default.drivers,
    identity: identity,
    gqlMarketplaceEntity: gqlMarketplaceEntity,
    placementDrivers: (placementDrivers === null || placementDrivers === void 0 ? void 0 : placementDrivers.map(function (driver) {
      return (0, _render.normalizeEntityPlacementDriver)(driver, driverRenderer);
    })) || (gqlMarketplaceEntity === null || gqlMarketplaceEntity === void 0 ? void 0 : (_placementDrivers = gqlMarketplaceEntity.placementDrivers) === null || _placementDrivers === void 0 ? void 0 : _placementDrivers.map(function (driver) {
      return (0, _render.normalizeEntityPlacementDriver)(driver, driverRenderer);
    })),
    shouldShowMatchScoreCta: shouldShowMatchScoreCta,
    shouldShowNAValues: shouldShowNAValues,
    shouldOmitCreditScoreDriver: shouldOmitCreditScoreDriver,
    showCreditScorePill: showCreditScorePill
  }), !!(tabs !== null && tabs !== void 0 && tabs.length) ? /*#__PURE__*/_react.default.createElement(_content.Content, {
    analytics: analytics === null || analytics === void 0 ? void 0 : analytics.contentProps,
    bottomLine: bottomLine || (gqlMarketplaceEntity !== null && gqlMarketplaceEntity !== void 0 && gqlMarketplaceEntity.structuredContentTagline ? null : /*#__PURE__*/_react.default.createElement(BottomLineRenderer, null, gqlMarketplaceEntity === null || gqlMarketplaceEntity === void 0 ? void 0 : gqlMarketplaceEntity.structuredContentTagline)),
    cons: cons || (gqlMarketplaceEntity === null || gqlMarketplaceEntity === void 0 ? void 0 : (_structuredContentCon = gqlMarketplaceEntity.structuredContentCons) === null || _structuredContentCon === void 0 ? void 0 : _structuredContentCon.map(consRenderer)),
    id: gqlMarketplaceEntity === null || gqlMarketplaceEntity === void 0 ? void 0 : gqlMarketplaceEntity.id,
    isInitTabContentExpanded: isInitTabContentExpanded,
    keyFacts: keyFacts,
    tabs: tabs,
    productDetails: productDetails,
    pros: pros || (gqlMarketplaceEntity === null || gqlMarketplaceEntity === void 0 ? void 0 : (_structuredContentPro = gqlMarketplaceEntity.structuredContentPros) === null || _structuredContentPro === void 0 ? void 0 : _structuredContentPro.map(prosRenderer)),
    reviewLinkNode: /*#__PURE__*/_react.default.createElement(_reactMarketplaceReviewLink.GraphQlMarketplaceReviewLink, {
      className: _marketplaceProductCardModule.default.tabContent_reviewLink,
      href: reviewLinkHref,
      marketplaceEntity: gqlMarketplaceEntity,
      text: "Read full review",
      trkPageType: trkPageType,
      trkTaxonomy: trkTaxonomy
    }),
    shouldOmitExpandFunctionalityOnMobile: hasAccordionOnMobile,
    trkSectionPosition: trkSectionPosition,
    hasAccordionDetails: shouldHideDetails
  }) : null);
  var header = /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_header.Header, {
    heading: heading || (gqlMarketplaceEntity === null || gqlMarketplaceEntity === void 0 ? void 0 : gqlMarketplaceEntity.displayName),
    shouldOmitCta: shouldOmitCta,
    shouldOmitRating: shouldOmitRating,
    applyNowNode: /*#__PURE__*/_react.default.createElement(_reactMarketplaceCta.default, {
      analyticsPayloadOverrides: getMarketplaceCtaAnalyticsPayload(),
      cta: cta,
      disableAnnotation: true,
      gqlMarketplaceEntity: gqlMarketplaceEntity,
      id: "".concat(_constants.TRK_PRODUCT_LOCATION, "__header-cta-").concat(gqlMarketplaceEntity === null || gqlMarketplaceEntity === void 0 ? void 0 : gqlMarketplaceEntity.id),
      legacyTrkProps: {
        trkElementPosition: trkElementPosition,
        trkLocation: _constants.TRK_PRODUCT_LOCATION,
        trkPageType: trkPageType,
        trkSectionCategory: mpcTrkSectionCategory,
        trkTaxonomy: trkTaxonomy
      },
      linkType: _reactMarketplaceCta.LINK_TYPES.applyLink,
      omitImpression: true,
      reviewLinkOverride: reviewLinkHref,
      urlSearchParams: ctaTrackingParams
    }),
    starRatingNode: /*#__PURE__*/_react.default.createElement(_reactMarketplaceStarRating.GraphQlMarketplaceStarRating, {
      analytics: analytics === null || analytics === void 0 ? void 0 : analytics.headerProps,
      hideRatingText: shouldOmitRatingText,
      marketplaceEntity: gqlMarketplaceEntity,
      omitRatingTextHref: omitRatingTextHref,
      ratingTextHref: reviewLinkHref,
      trkLocation: _constants.TRK_PRODUCT_LOCATION // TODO stop passing this through
      ,
      trkPageType: trkPageType,
      trkTaxonomy: trkTaxonomy
    })
  }), getProductCtas(_marketplaceProductCardModule.default['productCtas--underHeader'], 'under-header'));
  var imageAndCtas = /*#__PURE__*/_react.default.createElement(_react.Fragment, null, !!(imageData !== null && imageData !== void 0 && imageData.src) && (shouldOmitCta ? productCardImage : /*#__PURE__*/_react.default.createElement(_reactMarketplaceCta.default, {
    analyticsPayloadOverrides: getMarketplaceCtaAnalyticsPayload(),
    cta: cta,
    disableAnnotation: true,
    gqlMarketplaceEntity: gqlMarketplaceEntity,
    id: "".concat(_constants.TRK_PRODUCT_LOCATION, "__product-image--").concat(trkSectionPosition, "-").concat(gqlMarketplaceEntity === null || gqlMarketplaceEntity === void 0 ? void 0 : gqlMarketplaceEntity.id),
    omitImpression: true,
    reviewLinkOverride: reviewLinkHref,
    linkType: _reactMarketplaceCta.LINK_TYPES.productImage,
    urlSearchParams: ctaTrackingParams,
    legacyTrkProps: {
      trkElementPosition: trkElementPosition,
      trkLocation: _constants.TRK_PRODUCT_LOCATION,
      trkPageType: trkPageType,
      trkSectionCategory: mpcTrkSectionCategory,
      trkTaxonomy: trkTaxonomy
    }
  }, productCardImage)), getProductCtas(_marketplaceProductCardModule.default['productCtas--underImage'], 'under-image'));
  var preheaderData = {};
  var productCardBanner = hasBanner ? /*#__PURE__*/_react.default.createElement(_reactProductCardBanner.default, {
    type: bannerType,
    text: bannerText
  }) : null;
  if (showBestOfAwards) {
    var _gqlMarketplaceEntity;
    var thisYearAwards = (_gqlMarketplaceEntity = gqlMarketplaceEntity.bestOfAwards) === null || _gqlMarketplaceEntity === void 0 ? void 0 : _gqlMarketplaceEntity.filter(function (value) {
      return value.year === new Date().getFullYear();
    });
    if (thisYearAwards !== null && thisYearAwards !== void 0 && thisYearAwards.length) {
      var thisYearAwardsText = thisYearAwards.map(function (value) {
        return value.category;
      }).join(', ');
      preheaderData.type = _preheader.PREHEADER_TYPE.BADGE;
      preheaderData.text = thisYearAwardsText;
      preheaderData.hoverText = thisYearAwardsText;
    }
  } else if (!(0, _isEmpty2.default)(preheaderConfig)) {
    preheaderData.type = preheaderConfig.type;
    preheaderData.text = preheaderConfig.text;
    preheaderData.hoverText = preheaderConfig.hoverText;
  }
  var preheader = !(0, _isEmpty2.default)(preheaderData) && !addCategoryHeader ? /*#__PURE__*/_react.default.createElement(_preheader.default, {
    className: _marketplaceProductCardModule.default.preheader,
    trkTaxonomy: trkTaxonomy,
    text: preheaderData === null || preheaderData === void 0 ? void 0 : preheaderData.text,
    title: preheaderData === null || preheaderData === void 0 ? void 0 : preheaderData.hoverText,
    trkPageType: trkPageType,
    sentiment: preheaderConfig === null || preheaderConfig === void 0 ? void 0 : preheaderConfig.sentiment,
    type: preheaderData === null || preheaderData === void 0 ? void 0 : preheaderData.type,
    url: preheaderConfig === null || preheaderConfig === void 0 ? void 0 : preheaderConfig.url
  }) : null;
  var categoryHeader = addCategoryHeader && !(0, _isEmpty2.default)(preheaderData) ? /*#__PURE__*/_react.default.createElement("div", {
    className: _marketplaceProductCardModule.default.categoryHeaderWrapper
  }, /*#__PURE__*/_react.default.createElement(_currency.Type, {
    light: true,
    size: 2
  }, preheaderData === null || preheaderData === void 0 ? void 0 : preheaderData.text)) : null;
  var matchScoreCta = shouldShowMatchScoreCta && (0, _utils.isCCOffer)(gqlMarketplaceEntity) ? /*#__PURE__*/_react.default.createElement(_matchScoreCta.GraphqlMatchScoreCTA, {
    analytics: analytics === null || analytics === void 0 ? void 0 : analytics.matchScoreCTAProps,
    approvalLikelihood: approvalLikelihood,
    identity: identity,
    taxonomy: trkTaxonomy,
    marketplaceEntity: gqlMarketplaceEntity
  }) : null;
  var productCardClasses = addCategoryHeader ? [className, _marketplaceProductCardModule.default.productCardWithCategoryHeader] : [className];
  return /*#__PURE__*/_react.default.createElement(_baseMarketplaceProductCardScaffold.default, {
    addToFavoritesNode: shouldEnableFavorites ? /*#__PURE__*/_react.default.createElement(_addToFavorites.default, {
      isFavorited: isFavorited,
      favoriteCallback: favoriteCallback
    }) : null,
    analytics: analytics === null || analytics === void 0 ? void 0 : (_analytics$contentPro = analytics.contentProps) === null || _analytics$contentPro === void 0 ? void 0 : _analytics$contentPro.expandableContentProps,
    className: (0, _classnames.default)(productCardClasses),
    driversAndContentNode: driversAndContent,
    hasAccordionOnMobile: hasAccordionOnMobile,
    hasPreheaderBadge: (preheaderData === null || preheaderData === void 0 ? void 0 : preheaderData.type) === _preheader.PREHEADER_TYPE.BADGE,
    headerNode: header,
    imageNode: imageAndCtas,
    matchScoreCtaNode: matchScoreCta,
    preheaderNode: preheader,
    categoryHeaderNode: categoryHeader,
    bannerNode: productCardBanner
  });
};
GraphQlMarketplaceProductCard.fragment = (0, _apollo.gql)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  fragment GraphQlMarketplaceProductCard on MarketplaceEntityInterface {\n    __typename\n    id\n\n    ... on MarketplaceEntityWithBestOfAwardsInterface {\n      bestOfAwards {\n        year\n        category\n      }\n    }\n\n    ... on MarketplaceEntityWithPlacementInterface {\n      displayName\n      image {\n        ...getImageDataFromEntityPlacementImage\n      }\n      placementDrivers {\n        ...normalizeEntityPlacementDriver\n      }\n      structuredContentPros\n      structuredContentCons\n      structuredContentTagline\n    }\n    ... on CreditCardsOfferV2 {\n      legacyId\n      ratesAndFeesCta {\n        # TODO: Extract this from MarketplaceCta or remove secondaryCta concept\n        link\n        showIcon\n        subtext\n        text\n        type\n      }\n      ...GraphqlMatchScoreCTA\n    }\n    ...MarketplaceReviewLink\n    ...MarketplaceCta\n    ...MarketplaceStarRating\n    ...GqlProductDrivers\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), _utils.getImageDataFromEntityPlacementImage.fragment, _render.normalizeEntityPlacementDriver.fragment, _reactMarketplaceCta.default.fragment, _reactMarketplaceReviewLink.GraphQlMarketplaceReviewLink.fragment, _reactMarketplaceStarRating.GraphQlMarketplaceStarRating.fragment, _matchScoreCta.GraphqlMatchScoreCTA.fragment, _drivers.GqlProductDrivers.fragment);
if (process.env.NODE_ENV !== 'production') {
  /* eslint-disable-next-line global-require, @typescript-eslint/no-var-requires */
  var PropTypes = require('prop-types');
  var _require = require('./prop-types'),
    EntityPlacementCtaPropType = _require.EntityPlacementCtaPropType,
    EntityPlacementDriverPropType = _require.EntityPlacementDriverPropType,
    EntityPlacementImagePropType = _require.EntityPlacementImagePropType,
    MarketplaceProductCardAnalyticsPropType = _require.MarketplaceProductCardAnalyticsPropType,
    StructuredContentProps = _require.StructuredContentProps,
    TRKPropTypes = _require.TRKPropTypes; // eslint-disable-line global-require, @typescript-eslint/no-var-requires

  GraphQlMarketplaceProductCard.propTypes = {
    analytics: MarketplaceProductCardAnalyticsPropType,
    approvalOddsEnabled: PropTypes.bool,
    bottomLine: PropTypes.node,
    className: PropTypes.string,
    cons: PropTypes.arrayOf(PropTypes.node),
    cta: EntityPlacementCtaPropType,
    ctaTrackingParams: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string
    })),
    gqlMarketplaceEntity: PropTypes.shape({
      __typename: PropTypes.string,
      bestOfAwards: PropTypes.arrayOf(PropTypes.shape({
        year: PropTypes.number,
        category: PropTypes.string
      })),
      cta: EntityPlacementCtaPropType,
      ratesAndFeesCta: EntityPlacementCtaPropType,
      id: PropTypes.string,
      image: EntityPlacementImagePropType,
      displayName: PropTypes.string,
      legacyId: PropTypes.number,
      structuredContentCons: PropTypes.arrayOf(StructuredContentProps),
      structuredContentPros: PropTypes.arrayOf(StructuredContentProps),
      structuredContentTagline: StructuredContentProps,
      placementDrivers: PropTypes.arrayOf(EntityPlacementDriverPropType)
    }).isRequired,
    hasAccordionOnMobile: PropTypes.bool,
    heading: PropTypes.node,
    identity: PropTypes.shape({
      profiles: PropTypes.shape({
        tu_credit_report_profile: PropTypes.shape({
          vantage_score_3: PropTypes.number
        })
      })
    }),
    image: EntityPlacementImagePropType,
    imageOverlay: PropTypes.node,
    isInitTabContentExpanded: PropTypes.bool,
    isLazyLoadEnabled: PropTypes.bool,
    keyFacts: PropTypes.node,
    placementDrivers: PropTypes.arrayOf(EntityPlacementDriverPropType),
    preheader: PropTypes.shape({
      hoverText: PropTypes.string,
      sentiment: PropTypes.oneOf(Object.values(_preheader.SENTIMENT_TYPE)),
      text: PropTypes.string.isRequired,
      type: PropTypes.oneOf(Object.values(_preheader.PREHEADER_TYPE)).isRequired,
      url: PropTypes.string
    }),
    productDetails: PropTypes.node,
    pros: PropTypes.arrayOf(PropTypes.node),
    reviewLinkHref: PropTypes.string,
    secondaryCta: EntityPlacementCtaPropType,
    shouldOmitCta: PropTypes.bool,
    shouldOmitRating: PropTypes.bool,
    shouldOmitRatingText: PropTypes.bool,
    shouldShowMatchScoreCta: PropTypes.bool,
    shouldShowNAValues: PropTypes.bool,
    shouldOmitCreditScoreDriver: PropTypes.bool,
    tabs: PropTypes.arrayOf(PropTypes.oneOf(Object.values(_generatedTypes.ProductCardContentTabEnum))),
    trkElementPosition: PropTypes.number,
    trkPageType: PropTypes.string,
    trkSectionCategory: PropTypes.string,
    trkSectionPosition: PropTypes.number,
    trkTaxonomy: TRKPropTypes,
    shouldHideDetails: PropTypes.boolean,
    hasBanner: PropTypes.bool,
    bannerText: PropTypes.string,
    bannerType: PropTypes.oneOf((0, _values2.default)(_reactProductCardBanner.ProductCardBannerTypes)),
    addCategoryHeader: PropTypes.bool
  };
}
var _default = GraphQlMarketplaceProductCard;
exports.default = _default;